var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKosovo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b48a1",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8a75e",
    d: "M15.16 8.2c-.06 1.36 1.36.39 1.83 1.49.49.44.64 1.52 1.73 1.46-.16.78-.33.97.56 1.15.45-.26.47.23.77.39.24-.07.73-.3.86.19-.37.91-.73 1.95-1.3 2.44-1.15-.03 1.32 1.15-.43.92-.24-.59-.68.28-1.04.36-.1 1.02-.7 1.25-1.15.17-3.9.52-1.32 2.44-3.4 2.62-.62-5.26-1.7-2.35-2.5-4.61-.12-.52-.58-.74-.93-1.1.25-.68.08-.87-.58-1.14-.07-.62.7-.87 1.2-.48.44-.13.6-.62 1.23-.65 1.03.04.74-.26.88-.98.52-.41.87-.23 1-.93.49-.17-.87-.71-.12-1.02.46-.08 1.06-.8 1.39-.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.71 5.47-.28-.85-.27.85h-.9l.73.53-.28.86.72-.53.73.53-.28-.86.73-.53zm2.83.5-.28-.85-.27.85h-.9l.73.53-.28.85.72-.53.73.53-.28-.85.73-.53zm2.7.98-.27-.85-.28.85h-.9l.73.53-.28.86.73-.53.72.53-.28-.86.73-.53zm-8.4-1.48-.28-.85-.27.85h-.9l.72.53-.27.86.72-.53.73.53L14 6l.73-.53zm-2.83.5-.27-.85-.28.85h-.9l.73.53-.28.85.73-.53.72.53-.28-.85.73-.53zm-2.7.98-.28-.85-.27.85h-.9l.73.53-.28.86.72-.53.73.53-.28-.86.73-.53z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKosovo);
export default __webpack_public_path__ + "static/media/kosovo.25ccce3cc889c9c9679b4a0f7ad29a10.svg";
export { ForwardRef as ReactComponent };